import { Routes } from '@angular/router';
import { OfferConfirmationComponent } from './components/offer-confirmation/offer-confirmation.component';
import { OfferDeclinedComponent } from './components/offer-declined/offer-declined.component';
import { OfferNotAvailableComponent } from './components/offer-not-available/offer-not-available.component';
import { OfferStatusComponent } from './components/offer-status/offer-status.component';
import { OfferTokenValidationComponent } from './components/offer-token-validation/offer-token-validation.component';
import { OfferFormEmailComponent } from './components/offer-form-email/offer-form-email.component';
import { SiteTermsAndConditionsComponent } from './components/site-terms-and-conditions/site-terms-and-conditions.component';
import { UnsubscribeFromEmailsComponent } from './components/unsubscribe-from-emails/unsubscribe-from-emails.component';
import { SitePrivacyPolicyComponent } from './components/site-privacy-policy/site-privacy-policy.component';
import { OfferConfirmationValidationSentComponent } from './components/offer-confirmation-validation-sent/offer-confirmation-validation-sent.component';
import { OfferConfirmationCodeComponent } from './components/offer-confirmation-code/offer-confirmation-code.component';
import { UiNewHomeComponent } from './components/_ui-new/ui-new-home/ui-new-home.component';
import { ThemeConfigComponent } from './components/theme-config/theme-config.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { OfferLinkRedirectComponent } from './components/offer-link-redirect/offer-link-redirect.component';

export const routes: Routes = [

    { 'path': 'offer/link/:prop_id/:key', component: OfferLinkRedirectComponent, pathMatch: 'full' },
    { 'path': 'offer/:alias_id/:prop_id', component: UiNewHomeComponent, pathMatch: 'full' },
    { 'path': 'offerStatus/:alias_id/:prop_id', component:OfferStatusComponent},
    // { 'path': 'offerConfirmation/:alias_id/:prop_id', component: OfferConfirmationComponent},
    { 'path': 'offerConfirmation/:alias_id/:prop_id/:token', component: OfferConfirmationCodeComponent},
    
    { 'path': 'offerTokenValidation/:alias_id/:prop_id', component: OfferTokenValidationComponent},
    { 'path': 'offerConfirmationValidation/:alias_id/:prop_id', component: OfferConfirmationValidationSentComponent},            
    { 'path': 'offerDeclined', component: OfferDeclinedComponent},
    { 'path': 'offerGuestEmail/:alias_id/:prop_id', component: OfferFormEmailComponent},   
    { 'path': 'offerNotAvailable', component: OfferNotAvailableComponent},
    { 'path': 'termsOfService', component: SiteTermsAndConditionsComponent},
    { 'path': 'privacyPolicy', component: SitePrivacyPolicyComponent},
    { 'path': 'theme-config', component: ThemeConfigComponent},
    { 'path': 'unauthorized', component: UnauthorizedComponent},

    { 'path': 'unsubscribe/:alias_id/:prop_id/:tenant_id/:email', component: UnsubscribeFromEmailsComponent},

    { 'path': '**',
        component: OfferNotAvailableComponent
    }

];
